<template>
  <div class="date-time-picker">
    <label
      v-if="header"
      class="date-time-picker__header"
      :style="{
        'font-size': header_font_size ? `${header_font_size}px` : `16px`,
        'font-weight': header_font_weight || '300',
        color: header_font_color || '#55616e',
      }"
      >{{ header }}</label
    >
    <div class="date-input" @click="clickDateTimePicker">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
          fill="currentColor"
          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
        />
      </svg>
      <span class="time">{{ outputTime }}</span>
    </div>
    <datetime
      ref="e"
      v-model="date_and_time"
      type="datetime"
      :use12-hour="false"
      :flow="['date', 'time']"
      input-class="date-time-picker-input"
      input-style="display: none"
    ></datetime>
  </div>
</template>

<script>
export default {
  props: [
    "header",
    "initial_time",
    "header_font_size",
    "header_font_weight",
    "header_font_color",
  ],
  data: () => {
    return {
      date_and_time: null,
      outputTime: null,
    };
  },
  watch: {
    date_and_time(date) {
      if (!date) {
        this.date_and_time = String(this.initial_time || new Date());

        return;
      }
      const transformedDate = this.transformDate(date);
      this.outputTime = this.drowDate(transformedDate);

      this.$emit("getTime", this.date_and_time);
    },
  },
  methods: {
    drowDate({ year, month, day, hour, minute, second }) {
      return `${year}:${month}:${day} ${hour}:${minute}:${second}`;
    },
    oneToTwoDigit(num) {
      return String(num).length === 1 ? `0${num}` : num;
    },
    transformDate(date) {
      const transformedDate = new Date(date);
      const year = transformedDate.getFullYear();
      const month = this.oneToTwoDigit(transformedDate.getMonth() + 1);
      const day = this.oneToTwoDigit(transformedDate.getDate());
      const hour = this.oneToTwoDigit(transformedDate.getHours());
      const minute = this.oneToTwoDigit(transformedDate.getMinutes());
      const second = this.oneToTwoDigit(transformedDate.getSeconds());

      return { year, month, day, hour, minute, second };
    },
    clickDateTimePicker(e) {
      this.$refs.e.$el.children[0].click();
    },
  },
};
</script>

<style lang="scss" scoped>
.date-time-picker {
  width: 100%;
  cursor: pointer;

  .date-time-picker__header {
    margin-bottom: 5px;
    font-family: Helvetica Neue;
    font-size: 16px;
    font-weight: 400;
    color: #55616e;
  }
  .date-input {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 0 10px;
    border: 1px solid #efefef;
    background: #fff;

    svg {
      width: 16px;
      margin-right: 8px;
      pointer-events: none;

      path {
        fill: #d4d4d4;
      }
    }
    .time {
      margin-right: 8px;
      color: #55616e;
      font-size: 15px;
      pointer-events: none;

      &::selection {
        background: transparent;
      }
    }
  }
}
</style>
